import { useLocalObservable } from 'mobx-react-lite';
import type { Path } from 'react-router-dom';

import { storage } from 'APP/packages/storage';
import { useLoginByCode } from 'APP/pages/authorization/hooks/useLoginByCode';
import { RouterLink, RouterParams } from 'APP/router/constants';
import Entities from 'STORE';

interface ICallInvitationLoginPagePresenter {
  isLoggingIn: boolean;
  isAuthenticated: boolean;
  homePagePath: Path | null;
  setIsLoggingIn(isLoggingIn: boolean): void;
}

export const useCallInvitationLoginPagePresenter = (): ICallInvitationLoginPagePresenter => {
  const { isLoggingIn } = useLoginByCode();

  const presenter = useLocalObservable<ICallInvitationLoginPagePresenter>(() => ({
    isLoggingIn,

    get isAuthenticated(): boolean {
      return Entities.authStore.isAuthenticated && Entities.usersStore.Me?.isUserValid;
    },

    get homePagePath(): Path | null {
      if (presenter.isLoggingIn) {
        return null;
      }
      const savedChannelId = storage.guestCall.getGuestCallChannelId();
      let search = '';

      if (savedChannelId) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(RouterParams.roomCallChannelId, savedChannelId);
        search = `?${searchParams.toString()}`;
      }

      return {
        pathname: RouterLink.Main,
        search,
        hash: '',
      };
    },

    setIsLoggingIn(isLoggingIn: boolean): void {
      presenter.isLoggingIn = isLoggingIn;
    },
  }));

  return presenter;
};
